<template>
  <div class="nc-accordion">
    <div class="nc-accordion__header" @click="toggle">
      <slot name="header">
        <span class="nc-accordion__title">{{ title }}</span>
        <span v-if="subtitle" class="nc-accordion__subtitle">{{ subtitle }}</span>
      </slot>
      <mdicon :name="isOpen ? 'chevron-up' : 'chevron-down'" size="18" class="nc-accordion__arrow" />
    </div>
    <div v-if="isOpen" class="nc-accordion__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NcAccordion',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    open: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpen: this.open,
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('toggle', this.isOpen);
    },
  },
  watch: {
    open(val) { this.isOpen = val; },
  },
};
</script>

<style scoped>
.nc-accordion {
  background: var(--nc-bg-card);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.nc-accordion + .nc-accordion { margin-top: 8px; }
.nc-accordion__header {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  cursor: pointer;
  gap: 8px;
}
.nc-accordion__header:active { background: #f8f9fa; }
.nc-accordion__title {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: var(--nc-text, #1a1a2e);
}
.nc-accordion__subtitle {
  font-size: 12px;
  color: var(--nc-text-secondary, #92949c);
}
.nc-accordion__arrow {
  color: var(--nc-text-muted, #c8c9ce);
  flex-shrink: 0;
}
.nc-accordion__content {
  border-top: 1px solid #f0f0f2;
}
</style>
